import React from "react";

// Material UI
import { Stack, Typography, Tooltip, Switch, Zoom } from "@mui/material";

// Styles
import { textStyles, commonStyles } from "Common/Styles";

const AdminSwitchSetting = ({
  id,
  name,
  tooltipInfo,
  isChecked,
  onChange,
  viewOnly = false,
}) => {
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Typography sx={textStyles.subtitle}>{name}</Typography>
      <Tooltip arrow slots={{ transition: Zoom }} title={tooltipInfo}>
        <Switch
          id={id}
          checked={isChecked}
          onChange={onChange}
          disabled={viewOnly}
          sx={commonStyles.terracottaSwitch}
        />
      </Tooltip>
    </Stack>
  );
};

export default AdminSwitchSetting;
